import Vue from 'vue'
import Vuex from 'vuex'
import {store} from "./app/store/store"
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import VueTheMask from 'vue-the-mask'


Vue.config.productionTip = false
Vue.use(VueTheMask)


/**
 * Globais
 */
Vue.prototype.$formmasks = {  cpf:'###.###.###-##', 
                              cnpj:'##.###.###/####-##',
                              share: ['###.##','##.##']
                            };

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
